import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class PortalPageSlider {
	constructor($el) {
		this.$el = $el;

		this.options = {
			// autoPlay: true,
			pageDots: false,
			wrapAround: true,
			prevNextButtons: true,
			freeScroll: false,
			cellSelector: ".page-portal__header-slider-item",
		};

		if (this.$el.length) {
			this._init();
		}
	}

	_init() {
        this.$slides = this.$el.find('.page-portal__header-slider-item');
        this.slidesCount = this.$slides.length;

        if(this.slidesCount > 0) {
            this._createSlider();
        }
    }

	_createSlider() {
        new Flickity(this.$el[0], this.options);
    }
}

export default PortalPageSlider;
